import { render } from "./departmentSelectModel.vue?vue&type=template&id=6fa11176"
import script from "./departmentSelectModel.vue?vue&type=script&lang=js"
export * from "./departmentSelectModel.vue?vue&type=script&lang=js"

import "./departmentSelectModel.vue?vue&type=style&index=0&id=6fa11176&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__